import { get, post } from "../helpers/config";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";

export type MarketingSendEmailPayload = {
  campaignName: string;
  recipientSegment: "all" | "users" | "attendants" | "single";
  subject: string;
  body: string;
  audienceFilters?: string[];
  singleRecipientEmail?: string | null;
  testRecipientEmail?: string | null;
};

export type MarketingRecipientSearchResult = {
  userId: string;
  email: string;
  fullName: string | null;
  roleName: string;
};

export const useSendMarketingEmail = (
  options?: UseMutationOptions<any, any, MarketingSendEmailPayload, any>
) => {
  return useMutation<any, any, MarketingSendEmailPayload, any>(async (data) => {
    return await post("marketing/send-email", data);
  }, options);
};

export const useGetMarketingAudienceSummary = (
  options?: UseMutationOptions<any, any, void, any>
) => {
  return useMutation<any, any, void, any>(async () => {
    return await get("marketing/audience-summary");
  }, options);
};

export const useSearchMarketingRecipients = (
  options?: UseMutationOptions<any, any, string, any>
) => {
  return useMutation<any, any, string, any>(async (query) => {
    return await get(`marketing/search-recipients?query=${encodeURIComponent(query)}`);
  }, options);
};
